// @flow

import DateService from 'web-core/src/date-service';
import type { Dispatch } from 'redux';
import type {
  GetEnrollmentDateParamsType,
  EnrollmentPeriodResType as EPRT,
} from 'web-core/types/enrollment';
import type { GetStateType } from 'types/store';

export const RECEIVE_PERIODS: 'RECEIVE_PERIODS' = 'RECEIVE_PERIODS';

type ReceivePeriodsAction = { type: 'RECEIVE_PERIODS', periods: EPRT };

const receivePeriods: (periods: EPRT) => ReceivePeriodsAction = (periods: EPRT) => ({
  type: RECEIVE_PERIODS,
  periods,
});

type GetAppEffectiveDateArgs = {
  params: GetEnrollmentDateParamsType,
  options: Object,
};

type GetPeriodsParamsType = {
  ...GetEnrollmentDateParamsType,
  clientDate?: boolean | string,
};

export const getAppEffectiveDate = ({ params, options }: GetAppEffectiveDateArgs) => (
  dispatch: Function,
  getState: GetStateType,
  { apiClient }: Object,
) => {
  const svc = new DateService({ client: apiClient });

  return svc.getAppEffectiveDate(params, options);
};

export const getPeriods = (params: GetPeriodsParamsType = {}) => (
  dispatch: Dispatch<ReceivePeriodsAction>,
  getState: GetStateType,
  { apiClient }: Object,
) => {
  const svc = new DateService({ client: apiClient });

  return svc.getEnrollmentPeriods(params).then((res) => {
    dispatch(receivePeriods(res));

    return res;
  });
};
